<template>
  <div>
    <v-card class="no-shadow">
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center"
          ><v-icon>mdi-card-text-outline</v-icon> Gestión de Solicitud de
          Materiales</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <template>
          <!-- <v-btn class="btn-principal" @click="mostrarDialogo">
            <v-icon>mdi-plus</v-icon>
            Crear Solicitud
          </v-btn> -->
          <label class="custom-file-upload mt-2">
            <input type="file" @change="onFileSelect" />
            <i class="fa fa-cloud-upload"></i> Crear Solicitud
          </label>
        </template>
      </v-toolbar>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
        class="mb-4"
      ></v-text-field>
      <v-data-table
        :headers="headers"
        :items="tickets"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:[`item.estado`]="{ item }">
          <v-chip :color="getColor(item.estado)" dark>
            {{ item.estado }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="viewItem(item)">
            mdi-eye
          </v-icon>
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          No hay items
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >¿Estás seguro que deseas eliminar este ticket?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Volver</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="crateEditVer" max-width="500px">
      <createTickets
        :titulo="tituloDialogo"
        :disabledTicket="disabledTicket"
        :dataTicket="dataTicket"
        v-on:recibeTickect="recibeTickect"
      />
    </v-dialog>
  </div>
</template>
<script>
import UserProfile from "../../data";
import createTickets from "../tickets/create-tickets.vue";
import XLSX from "xlsx";

export default {
  components: {
    createTickets,
  },
  data: () => ({
    dataTicket: {},
    disabledTicket: false,
    user: UserProfile.getUserData(),
    search: "",
    tituloDialogo: "Nuevo ticket",
    dialog: false,
    crateEditVer: false,
    dialogDelete: false,
    lugares: ["Cliente", "Instalación"],
    tiposPlanificacion: ["Programado", "No programado"],
    tiposCreador: [
      "Cliente administrador",
      "Cliente usuario final",
      "FC de la locación",
      "FC fuera de la locación",
    ],
    tiposServicios: [
      "Aseo tradicional",
      "Aseo terminal",
      "Aseo recurrente",
      "Programa de aseo",
      "Vidrios a nivel",
      "Vidrios en altura",
      "Limpieza en altura",
    ],
    gruposTareas: ["Fin de semana", "Cada 15 días", "Cada 30 días"],
    parametrosLugar: ["Dirección", "Recinto", "Piso", "Zona/Área"],
    tiposTicket: [
      "Capacitación",
      "Tarea de RRHH",
      "Tarea administrativa",
      "Aviso cambio RRHH",
      "Mantenimiento de equipos",
    ],
    asignacion: ["Cuadrilla", "Persona", "Cargo"],
    estadoTicket: ["No leído", "Abierto", "Resuelto", "Cerrado"],
    headers: [
      {
        text: "Cliente",
        align: "start",
        sortable: false,
        value: "cliente",
      },
      { text: "Instalación", value: "instalacion" },
      { text: "Código", value: "codigo" },
      { text: "Categoría", value: "categoria" },
      { text: "Producto", value: "producto" },
      { text: "Talla", value: "talla" },
      { text: "color", value: "color" },
      { text: "Presentacion", value: "presentacion" },
      { text: "Pedido", value: "pedido" },
      { text: "Aprobación", value: "aprobacion" },
      { text: "Proveedor", value: "proveedor" },
      { text: "Autorización", value: "autorizacion" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    tickets: [],
    editedIndex: -1,
    editedItem: {
      cliente: "",
      instalacion: "",
      codigo: "",
      categoria: "",
      producto: "",
      talla: "",
      color: "",
      presentacion: "",
      pedido: "",
      aprobacion: "",
      proveedor: "",
      autorizacion: "",
    },
  }),
  mounted() {
    // this.editedItem.creado_por = this.user.user;
  },
  computed: {
    formTitle() {
      // this.editedItem.creado_por = this.user.user;

      return this.editedIndex === -1 ? "Nuevo ticket" : "Editar ticket";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    onFileSelect(files) {
      if (files.length === 0) {
        return;
      }
      let workBook = null;
      let jsonData = null;
      this.file = files.target.files[0];

      const reader = new FileReader();
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: "binary" });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          return XLSX.utils.sheet_to_json(sheet);
        }, {});

        const clientes = jsonData.map((clientesJson, i) =>
          this.cleanUndefined({
            cliente: this.cleanUndefined(clientesJson["CLIENTE"]),
            instalacion: this.cleanUndefined(clientesJson["INSTALACION"]),
            codigo: this.cleanUndefined(clientesJson["CÓDIGO"]),
            categoria: this.cleanUndefined(
              clientesJson["CATEGORÍA"]
            ).toString(),
            producto: this.cleanUndefined(clientesJson["PRODUCTO"]),
            talla: this.cleanUndefined(clientesJson["TALLA"]),
            COLOR: this.cleanUndefined(clientesJson["COLOR"]),
            presentacion: this.cleanUndefined(clientesJson["PRESENTACION"]),
            pedido: this.cleanUndefined(clientesJson["PEDIDO"]),
            aprobacion: this.cleanUndefined(clientesJson["APROBACIÓN"]),
            proveedor: this.cleanUndefined(clientesJson["PROVEEDOR"]),
            autorizacion: this.cleanUndefined(clientesJson["AUTORIZACIÓN"]),
          })
        );
console.log("soy " , clientes);
        this.validateClient(clientes);
      };
      reader.readAsBinaryString(this.file);
    },

    cleanUndefined(data) {
      return data ? data : "";
    },
    async validateClient(clients) {
      console.log("golaa", clients);
      // const dniArray = clients
      //   .map((c) => this.runFormatting(c.dni))
      //   .filter((d) => this.runValidation(d))
      //   .map((d) => this.runClean(d))
      // let response = await this.$store.dispatch('ficha-cliente/getFichas', {
      //   where: {
      //     and: [
      //       { dni: { inq: dniArray } },
      //       { companyId: this.$auth.user.company.id }
      //     ]
      //   }
      // })

      // this.fillTableList(clients, response)
    },

    recibeTickect(item) {
      console.log("estoy aqui", item);
      this.crateEditVer = false;

      if (item !== undefined) this.tickets.push(item);
    },
    mostrarDialogo() {
      this.crateEditVer = true;
      this.disabledTicket = false;
      this.dataTicket = {};
    },

    initialize() {
      this.tickets = [
        {
          cliente: "Cliente",
          instalacion: "Instalación",
          codigo: "Código",
          categoria: "Categoría",
          producto: "Producto",
          talla: "Talla",
          color: "color",
          presentacion: "Presentacion",
          pedido: "Pedido",
          aprobacion: "Aprobación",
          proveedor: "Proveedor",
          autorizacion: "Autorización",
        },
      ];
    },
    getColor(estado) {
      if (estado == "No leído") return "default";
      else if (estado == "Resuelto") return "green";
      else if (estado == "Abierto") return "orange";
      else if (estado == "Cerrado") return "red";
    },

    editItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.editedItem = item;
      this.dialog = true;
      console.log(item);
      this.dataTicket = item;
      (this.tituloDialogo = "Editar ticket"), (this.crateEditVer = true);
      this.disabledTicket = false;
    },

    deleteItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.dialogDelete = true;
    },

    viewItem(item) {
      this.editedIndex = this.tickets.indexOf(item);
      this.editedItem = item;
      (this.tituloDialogo = "Ver ticket"), (this.crateEditVer = true);
      this.dataTicket = item;
      this.disabledTicket = true;
      console.log("se vio");
    },

    deleteItemConfirm() {
      this.tickets.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.tickets[this.editedIndex], this.editedItem);
      } else {
        this.tickets.push(this.editedItem);
      }
      this.close();
    },
  },
};
</script>

<style lang="scss">
.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}
.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}
.v-text-field__details {
  display: none;
}
.custom-file-upload {
  border: 1px solid #009edf;
  color: white;
  background-color: #009edf;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 16px;
  border-radius: 0.3rem;
}
input[type="file"] {
  display: none;
}
</style>
